import { render, staticRenderFns } from "./AppConfirmLeavePageModal.vue?vue&type=template&id=87c33d1a&"
import script from "./AppConfirmLeavePageModal.vue?vue&type=script&lang=js&"
export * from "./AppConfirmLeavePageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports